import { Component, Input, inject } from '@angular/core';
import { injectStripe } from 'ngx-stripe';
import { PaymentStripeServiceService } from '../../modules/service/payment/payment-stripe-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-payment-website',
  templateUrl: './payment-website.component.html',
  styleUrl: './payment-website.component.scss'
})
export class PaymentWebsiteComponent {
  @Input() paymentStatus :any;
  @Input() errormsg:any=null;
  plan:any;
  @Input() confirmSubscription:any;
  @Input() subStatus: any;

  private readonly stripeService = inject(PaymentStripeServiceService);
  readonly stripe = injectStripe(this.stripeService.StripePublicKey);
  constructor(private router:Router,private route:ActivatedRoute,private activeModal: NgbActiveModal,private spinner: NgxSpinnerService){}
 
  ngOnInit(){
    let plans:any = sessionStorage.getItem('plan');
    this.plan =JSON.parse(plans)
    this.spinner.hide();
 console.log(this.subStatus)
  }

  close(){
    if(this.confirmSubscription){
     this.router.navigate(['/home'])
    }
    this.activeModal.close();
  }
}
